module.exports = __webpack_public_path__ + "img/messenger.15d9c8a5.svg";